import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate, useLocation } from 'react-router-dom';
import './HotFix.css';

const HotFix = () => {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [menuColor, setMenuColor] = useState('white'); // <-- dynamic color

  const handleMenuClick = () => {
    setShowMenu(!showMenu);
  };

  const handleNavigation = (sectionId) => {
    setShowMenu(false);

    if (sectionId === 'contact-section') {
      navigate('/contact');
      setTimeout(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }, 10);
      return;
    }

    if (location.pathname === '/') {
      const section = document.getElementById(sectionId);
      if (section) section.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/', { state: { scrollTo: sectionId } });
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) section.scrollIntoView({ behavior: 'smooth' });
      }, 10);
    }
  };

  // 👇 Scroll logic for hamburger menu color
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('div[id$="-section"]');
      const scrollPosition = window.scrollY;
      let currentSectionId = 'hero-section'; // default

      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        const sectionTop = rect.top + window.scrollY;

        // Only change when section top reaches the top of the viewport
        if (scrollPosition >= sectionTop - 5) {
          currentSectionId = section.id;
        }
      });

      // Set color based on section
      switch (currentSectionId) {
        case 'hero-section':
          setMenuColor('white');
          break;
        case 'about-us-section':
          setMenuColor('black');
          break;
        case 'video-section':
          setMenuColor('white');
          break;
        case 'team-section':
          setMenuColor('black');
          break;
        case 'youtube-section':
          setMenuColor('white');
          break;
        case 'shop-section':
          setMenuColor('white');
          break;
        case 'club2-section':
          setMenuColor('white');
          break;
        default:
          setMenuColor('white');
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // initialize on load
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Mobile Menu Button */}
      <button className="hotfix-menu-button" onClick={handleMenuClick}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke={menuColor}
          strokeWidth="3"
          style={{ transition: 'stroke 0.3s ease' }}
        >
        <line x1="3" y1="6" x2="21" y2="6" />
        <line x1="3" y1="16" x2="21" y2="16" />
        </svg>
      </button>

      {/* Menu Overlays */}
      {showMenu &&
        createPortal(
          <>
            <div className="hotfix-menu-overlay-desktop">
              <div className="hotfix-menu-items-desktop">
                <a
                  href="https://www.amazon.com/stores/page/461F3B89-6764-45E0-9B2E-AB413358D21B?store_ref=storeRecs_sa__x&ref_=nb_sb_ss_w_stores-v2-t2_k0_2_11_1_1&crid=34HFD8HVB14P9&sprefix=game+7+appa&redirect_store_id=461F3B89-6764-45E0-9B2E-AB413358D21B"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div>Shop</div>
                </a>

                <div onClick={() => handleNavigation('youtube-section')}>Content</div>
                <div onClick={() => handleNavigation('about-us-section')}>About Us</div>
                <div onClick={() => handleNavigation('contact-section')}>Contact Us</div>
                <div onClick={() => handleNavigation('team-section')}>The Team</div>

                <div className="hotfix-social-icons">
                  <a href="https://www.instagram.com/game7" target="_blank" rel="noopener noreferrer">
                    <img src="/home_data/section1/Vector2.svg" alt="Instagram" />
                  </a>
                </div>
              </div>
            </div>

            <div className="hotfix-menu-overlay-mobile">
              <div className="hotfix-menu-header">
                <img src="/header_data/img/Logo Homepage.svg" alt="Logo" className="hotfix-logo" />
                <button className="hotfix-close-button" onClick={handleMenuClick}>
                  X
                </button>
              </div>

              <div className="hotfix-menu-items">
                <a
                  href="https://www.amazon.com/stores/page/461F3B89-6764-45E0-9B2E-AB413358D21B?store_ref=storeRecs_sa__x&ref_=nb_sb_ss_w_stores-v2-t2_k0_2_11_1_1&crid=34HFD8HVB14P9&sprefix=game+7+appa&redirect_store_id=461F3B89-6764-45E0-9B2E-AB413358D21B"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div>Shop</div>
                </a>

                <div onClick={() => handleNavigation('youtube-section')}>Content</div>
                <div onClick={() => handleNavigation('about-us-section')}>About Us</div>
                <div onClick={() => handleNavigation('contact-section')}>Contact Us</div>
                <div onClick={() => handleNavigation('team-section')}>The Team</div>

                <div className="hotfix-social-icons">
                  <a href="https://www.instagram.com/game7" target="_blank" rel="noopener noreferrer">
                    <img src="/home_data/section1/Vector2.svg" alt="Instagram" />
                  </a>
                </div>
              </div>
            </div>
          </>,
          document.body
        )}
    </>
  );
};

export default HotFix;
